function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var querystring = require("querystring");

var React = require("react");

var styled = require("styled-components").default;

var resizer = require("iframe-resizer");

module.exports =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PatternDemo, _React$Component);

  function PatternDemo() {
    _classCallCheck(this, PatternDemo);

    return _possibleConstructorReturn(this, (PatternDemo.__proto__ || Object.getPrototypeOf(PatternDemo)).apply(this, arguments));
  }

  _createClass(PatternDemo, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var pattern = props.get(props.id);
      var src = props.src(props.id);

      if (!src) {
        return React.createElement(PatternDemoError, {
          message: "Could not find ".concat(props.id)
        });
      }

      var q = querystring.stringify({
        resize: true,
        reload: props.reload
      });
      return React.createElement(PatternFrame, {
        src: "".concat(src, "?").concat(q)
      });
    }
  }]);

  return PatternDemo;
}(React.Component);

function PatternDemoError(props) {
  return React.createElement(StyledPatternDemoError, null, React.createElement("div", null, props.message), props.snippet && React.createElement("pre", null, props.snippet));
}

var PatternFrame =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(PatternFrame, _React$Component2);

  function PatternFrame() {
    _classCallCheck(this, PatternFrame);

    return _possibleConstructorReturn(this, (PatternFrame.__proto__ || Object.getPrototypeOf(PatternFrame)).apply(this, arguments));
  }

  _createClass(PatternFrame, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.ref && !this.resizer) {
        resizer.iframeResizer({
          warningTimeout: 0,
          log: false
        }, this.ref);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var props = this.props;
      return React.createElement(StyledPatternFrame, _extends({
        ref: function ref(_ref) {
          return _this.ref = _ref;
        }
      }, props));
    }
  }]);

  return PatternFrame;
}(React.Component);

var StyledPatternFrame = styled.iframe.withConfig({
  displayName: "component-demo__StyledPatternFrame"
})(["width:100%;min-width:100%;border:0;"]);
var StyledPatternDemoError = styled.div.withConfig({
  displayName: "component-demo__StyledPatternDemoError"
})(["background:", ";color:#fff;padding:10px 15px;font-family:monospace;"], function (props) {
  return props.theme.colors.error;
});
var StyledFrame = styled.iframe.withConfig({
  displayName: "component-demo__StyledFrame"
})(["border:none;width:100%;"]);
//# sourceMappingURL=index.js.map